const SET_UPD_SHELTERT_NAME = 'SET_UPD_SHELTERT_NAME';
const SET_UPD_KOJIN_INFO = 'SET_UPD_KOJIN_INFO';

export default {
  SET_UPD_SHELTERT_NAME,
  SET_UPD_KOJIN_INFO
};
